import { render, staticRenderFns } from "./RegisterVerification.vue?vue&type=template&id=e76d20de&scoped=true&"
import script from "./RegisterVerification.vue?vue&type=script&lang=ts&"
export * from "./RegisterVerification.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterVerification.vue?vue&type=style&index=0&id=e76d20de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76d20de",
  null
  
)

export default component.exports